// Mock data for Continex — premium 20-year gateway concept (frontend-only)

export const BOOK_MEETING_URL = "https://calendly.com/business-tyc/introductory-call";

// Sibling ecosystem sites (outbound)
export const TRADEVESTA_URL = "https://www.trade-vesta.com";
export const BRANDSTAGE_URL = "https://brandstage-media.com";

export const navLinks = [
  { label: "Home", path: "/" },
  { label: "Services", path: "/services", dropdown: "services" },
  { label: "Sectors", path: "/#key-sectors" },
  { label: "Ecosystem", path: "/#ecosystem", dropdown: "ecosystem" },
  { label: "Insights", path: "/blog" },
  { label: "News & Events", path: "/news" },
  { label: "Contact", path: "/contact" },
];

// ---- HERO ----
export const hero = {
  image:
    "https://images.pexels.com/photos/30586755/pexels-photo-30586755.jpeg?auto=compress&cs=tinysrgb&w=1600",
  kicker: "Since 2007 · 20 Years in 2027",
  titleLead: "20 Years.",
  titleAccent: "Across Borders.",
  triad: ["Elevate", "Engage", "Expand"],
  subline: "Elevate your leadership profile. Engage through digital trade and investment platform. Expand your business globally.",
};

export const heroPathways = [
  {
    id: "international",
    icon: "Building2",
    color: "#1F3A5F",
    label: "International Companies",
    line: "Enter & Grow in India",
    to: "/services/indiaentry",
  },
  {
    id: "government",
    icon: "Landmark",
    color: "#B8862F",
    label: "Trade & Investment Organisations, Government Agencies",
    line: "Build Trade & Investment Connections",
    to: "/services/tradeadvisory",
  },
  {
    id: "indian",
    icon: "Users",
    color: "#4878A8",
    label: "Indian Companies",
    line: "Partner & Expand Globally",
    to: "/services/b2bmeetings",
  },
];

export const positioningStatement =
  "For two decades, Continex has connected international companies, governments and Indian enterprises — turning cross-border ambition into on-the-ground results.";

// ---- STRENGTH BLOCKS: EXPERIENCE / CONNECTIONS / EXECUTION ----
export const strengthBlocks = [
  {
    id: "experience",
    label: "Experience",
    title: "Two decades of trusted expertise",
    text: "Twenty years advising businesses and institutions on entering and growing across India and international markets.",
    image:
      "https://images.unsplash.com/photo-1659356576362-b5d6ace37de0?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "relationships",
    label: "Relationships",
    title: "Real people, real relationships",
    text: "Business across borders is built on trust. Our teams build genuine, lasting relationships with partners and clients.",
    image:
      "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "execution",
    label: "Execution",
    title: "Delivery that gets results",
    text: "Specialist teams that execute your expansion vision — from trade missions and delegations to partnerships on the ground.",
    image:
      "https://images.unsplash.com/photo-1568992687947-868a62a9f521?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "clients",
    label: "Clients",
    title: "Clients who grow with us",
    text: "Companies, governments and institutions who have partnered with us for years — and keep coming back.",
    image:
      "https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

// ---- ECOSYSTEM ----
export const ecosystem = {
  intro:
    "Built on relationships, evolving with business. Continex now extends into two specialist platforms — one connected business ecosystem.",
  anchor: {
    name: "CONTINEX",
    line: "Business Expansion & Trade Consulting",
  },
  branches: [
    {
      id: "tradevesta",
      name: "TradeVesta",
      tagline: "Digital Business Engagement",
      desc: "A digital platform connecting businesses, governments and trade organisations for cross-border engagement.",
      url: "https://www.trade-vesta.com",
      logo: "/brand/tradevesta-logo.png",
      placeholder: false,
      color: "#0E7C7B",
    },
    {
      id: "brandstage",
      name: "BrandStage",
      tagline: "Video-First Business Visibility",
      desc: "Video-first corporate profiles, leadership interviews and trade-show visibility that build credibility.",
      url: "https://brandstage-media.com",
      logo: "/brand/brandstage-logo.png",
      placeholder: false,
      color: "#E4545F",
    },
  ],
};

// ---- EVOLUTION / WHAT WE DO OVER 20 YEARS ----
export const evolution = {
  eyebrow: "Two Decades of Evolution",
  heading: "How the world changed — and how we evolved with it",
  intro:
    "Over the past twenty years, cross-border business has been transformed — by globalisation, digital platforms, shifting supply chains and the rise of video-first communication.",
  intro2:
    "Trade moves faster and more connected than ever, buyers expect instant credibility, and governments play a bigger role in enabling investment. Continex has evolved alongside every one of these shifts — growing from a focused consultancy into a connected ecosystem built for how business works today.",
  bgVideo: "A4maspGVJHg",
  bgVideoUrl:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_continex-site/artifacts/1e49blgh_WhatsApp%20Video%202026-08-14%20at%2021.07.55.mp4",
  bgEyebrow: "From our recent work",
  bgLine: "Two decades in motion — trade missions, partnerships and delegations across the world.",
  steps: [
    {
      year: "2007",
      title: "A cross-border consultancy",
      text: "Continex begins helping international companies enter India and Indian companies expand abroad — built on trusted relationships and on-ground execution.",
    },
    {
      year: "2010s",
      title: "Trade & investment at scale",
      text: "As globalisation accelerated, we deepened our work with governments and trade bodies — delivering trade missions, delegations and market programmes.",
    },
    {
      year: "2020s",
      title: "A digital, video-first world",
      text: "As business went digital and visibility became decisive, we evolved beyond consulting — extending into specialist platforms for engagement and profile.",
    },
    {
      year: "Today",
      title: "One connected ecosystem",
      text: "Continex now spans consulting, TradeVesta for digital trade engagement and BrandStage for business visibility — three capabilities, one ecosystem.",
    },
  ],
};
export const impactStats = [
  { value: "20+", label: "Years of expertise" },
  { value: "350+", label: "Clients served" },
  { value: "150+", label: "Trade & business missions delivered" },
  { value: "4", label: "Continents served" },
];

export const impactTiles = [
  {
    id: "expansion",
    label: "Business Expansion",
    text: "Market entry, customers, partners and representation.",
    image:
      "https://images.unsplash.com/photo-1638262052640-82e94d64664a?crop=entropy&cs=srgb&fm=jpg&q=85",
    to: "/services/indiaentry",
  },
  {
    id: "trade",
    label: "Trade & Investment",
    text: "Trade missions, delegations and government engagement.",
    image:
      "https://images.unsplash.com/photo-1761195696518-6384573549ea?crop=entropy&cs=srgb&fm=jpg&q=85",
    to: "/services/tradeadvisory",
  },
  {
    id: "global",
    label: "Global Partnerships",
    text: "International partners and cross-border collaboration.",
    image:
      "https://images.unsplash.com/photo-1573167507387-6b4b98cb7c13?crop=entropy&cs=srgb&fm=jpg&q=85",
    to: "/services/b2bmeetings",
  },
];

// ---- KEY SECTORS (six core photographic cards + click-through narratives) ----
export const keySectorsIntro = {
  eyebrow: "Key Sectors",
  heading: "Sector knowledge. Market access. International connections.",
  intro:
    "From mobility and manufacturing to food, textiles and life sciences, Continex connects sector opportunities with the companies, institutions and partners needed to move them forward.",
};

export const keySectors = [
  {
    id: "future-mobility",
    name: "Future Mobility",
    tag: "EV • Connected • Intelligent Mobility",
    blurb: "Connecting technologies that are reshaping how people and goods move.",
    image:
      "https://images.unsplash.com/photo-1593941707874-ef25b8b4a92b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    cta: "Discuss an India Mobility Opportunity",
    indiaOpportunity:
      "India is becoming an important global environment for electric, connected and intelligent mobility. Its strength lies in the combination of a large vehicle market, established OEM and component ecosystems, strong engineering talent, software capability and rapidly developing EV, battery and charging infrastructure. For international companies, India can therefore be a customer market, engineering base, manufacturing location and innovation partner.",
    corridors:
      "The UK brings particular strengths in advanced engineering, electrification, lightweighting, motorsport-derived technologies, software and mobility innovation. Southeast Asia offers fast-growing EV, two-wheeler, electronics and urban-mobility ecosystems, creating opportunities for cross-market technology and supply-chain partnerships. African markets add a different growth dimension: affordable mobility, public transport, local assembly, electric two- and three-wheelers and infrastructure solutions.",
    howWeHelp:
      "Continex can help international mobility companies identify the right Indian OEMs, Tier 1 suppliers, technology partners and market-entry opportunities. Support can include market mapping, targeted introductions, technology-partnership discussions, B2B programmes, localisation conversations and ongoing India business development. For Indian companies, Continex can also support international partner and market development across selected corridors.",
    experience: [
      "UK–India future mobility and automotive B2B engagement",
      "OEM and Tier 1 introductions in India",
      "EV, sensors, electronics and connected-mobility opportunities",
      "Technology and international partnership development",
    ],
  },
  {
    id: "automotive-manufacturing",
    name: "Automotive Manufacturing",
    tag: "OEM • Components • Advanced Engineering",
    blurb: "Connecting global engineering capability with India's automotive scale.",
    image:
      "https://images.unsplash.com/photo-1777642328916-d96fc156f32b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    cta: "Discuss an Automotive Opportunity",
    indiaOpportunity:
      "India combines one of the world's largest automotive markets with a deep and increasingly sophisticated component and manufacturing ecosystem. Its capabilities span vehicle production, components, precision engineering, electronics, tooling, testing, software and increasingly EV-specific systems. India's auto-component sector is also strengthening its position as a global sourcing base, supported by domestic scale and export growth.",
    corridors:
      "The UK–India corridor is especially relevant for specialised machinery, advanced engineering, automation, electronics, testing, lightweight materials and high-value automotive technologies. Southeast Asia's established automotive hubs offer complementary supply-chain, sourcing and manufacturing relationships. African markets present opportunities in vehicle assembly, components, industrial machinery and localisation as countries seek to build domestic manufacturing capability.",
    howWeHelp:
      "Continex supports overseas automotive and industrial companies seeking customers, suppliers, partners or representation in India. We can identify and qualify OEM and Tier-level opportunities, organise technical meetings, support sourcing and localisation, develop supplier relationships and maintain commercial follow-up. Continex can also help Indian manufacturers identify international customers, technologies and strategic partners.",
    experience: [
      "Long-standing engagement with automotive and component companies",
      "India market development for overseas component and technology suppliers",
      "Supplier identification and manufacturing partnerships",
      "UK–India automotive and advanced engineering programmes",
    ],
  },
  {
    id: "construction-agri-equipment",
    name: "Construction & Agri Equipment",
    tag: "Off-Highway • Machinery • Technology",
    blurb: "Engineering partnerships for infrastructure, productivity and mechanisation.",
    image:
      "https://images.unsplash.com/photo-1575281923032-f40d94ef6160?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    cta: "Discuss an Equipment Opportunity",
    indiaOpportunity:
      "India's continuing investment in infrastructure, construction and agricultural productivity supports a substantial ecosystem for construction equipment, tractors, agricultural machinery and off-highway technologies. The opportunity extends into sensors, controls, hydraulics, electronics, safety systems, electrification, precision agriculture and specialised components. India's established equipment OEM base also makes the country relevant for technology localisation and global sourcing.",
    corridors:
      "The UK offers specialist capability in advanced off-highway engineering, intelligent machinery, electrification and component technologies. Southeast Asia combines major infrastructure programmes with agriculture-intensive economies, creating demand for machinery, productivity technologies and equipment partnerships. Across Africa, infrastructure development and agricultural mechanisation create opportunities for durable equipment, local assembly, technology transfer and lifecycle support.",
    howWeHelp:
      "Continex can connect international equipment and component companies with Indian OEMs, engineering organisations, suppliers and distributors. We support market assessment, technical introductions, localisation and sourcing discussions, supplier development and ongoing business engagement. The same networks can help Indian companies explore Southeast Asian, UK and African partnerships where there is a clear technology or market fit.",
    experience: [
      "Engagement with construction and agricultural equipment OEM ecosystems",
      "Sensor, control and component technology market development",
      "Supplier and contract-manufacturing assessment in India",
      "International technology and distribution partner search",
    ],
  },
  {
    id: "food-processing-agri",
    name: "Food Processing & Agri",
    tag: "Processing • Agri-Tech • Value Addition",
    blurb: "Connecting India's agricultural scale with value-added food and technology.",
    image:
      "https://images.unsplash.com/photo-1651525670114-2b8117390b28?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    cta: "Discuss a Food & Agri Opportunity",
    indiaOpportunity:
      "India has one of the world's largest and most diverse agricultural bases and is a leading producer of milk, pulses and spices, with major output across fruits, vegetables, grains and other crops. This creates significant opportunities beyond primary agriculture in food processing, cold chain, storage, packaging, food safety, processing machinery, agri-tech and value-added products. India's policy focus is also expanding processing capacity and strengthening farm-to-market linkages.",
    corridors:
      "The UK offers technology, food innovation, retail, standards, processing and agri-tech capabilities that can complement India's scale. Southeast Asia provides natural opportunities around tropical agriculture, food processing, ingredients, machinery and regional distribution. African markets have significant long-term potential in agricultural productivity, processing, storage, cold chain and local value addition, creating scope for Indian and international technology partnerships.",
    howWeHelp:
      "Continex can help overseas companies identify processors, customers, distributors, technology partners and manufacturing opportunities in India. We can structure market visits, B2B programmes and partner searches around specific products or technologies. For Indian companies, Continex can support overseas market development and partnerships, particularly where processing, technology transfer, food supply chains or agricultural productivity are central to the opportunity.",
    experience: [
      "Business and institutional engagement across India and African markets",
      "Partner identification for processing and agri-business opportunities",
      "Trade and investment programme support",
      "Cross-border B2B and market-development programmes",
    ],
  },
  {
    id: "textiles-technical-textiles",
    name: "Textiles & Technical Textiles",
    tag: "Materials • Manufacturing • Sustainability",
    blurb: "From India's traditional textile strength to advanced functional materials.",
    image:
      "https://images.unsplash.com/photo-1610891015188-5369212db097?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    cta: "Discuss a Textiles Opportunity",
    indiaOpportunity:
      "India has a broad textile value chain spanning natural and man-made fibres, yarn, fabrics, garments, machinery and increasingly technical textiles. Its scale in cotton, jute and other materials is complemented by growing capability in engineered textiles used in automotive, construction, agriculture, medical, industrial safety and other applications. This creates opportunities in sourcing, manufacturing technology, sustainable materials, automation and higher-value functional products.",
    corridors:
      "The UK is a valuable corridor for technical textiles, advanced materials, sustainability, design, research and high-value market access; recent India–UK engagement has specifically highlighted technical textiles and circularity. Southeast Asia has a large apparel and textile manufacturing base and offers opportunities for materials, machinery, sustainable production and regional supply-chain collaboration. African markets provide longer-term potential in textile manufacturing, machinery, apparel value chains and local industrialisation.",
    howWeHelp:
      "Continex can help international textile, machinery and material-technology companies identify manufacturers, customers, sourcing partners and technology collaborators in India. We can also support Indian companies seeking international market access, technical partnerships and distribution. The strongest positioning for Continex is where textiles intersect with other sectors such as automotive, healthcare, construction, agriculture and sustainability.",
    experience: [
      "India–UK opportunity mapping and business engagement",
      "Manufacturing and sourcing partner identification",
      "Technical and functional textile applications across industrial sectors",
      "International market and technology partnership development",
    ],
  },
  {
    id: "pharmaceuticals-life-sciences",
    name: "Pharmaceuticals & Life Sciences",
    tag: "Pharma • Biotech • Healthcare",
    blurb: "Connecting India's scale in healthcare manufacturing with global science and innovation.",
    image:
      "https://images.unsplash.com/photo-1602052577122-f73b9710adba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    cta: "Discuss a Life Sciences Opportunity",
    indiaOpportunity:
      "India is a major global pharmaceutical manufacturing and export centre, with deep capabilities in formulations, generics, APIs, vaccines and an expanding biotechnology and life-sciences ecosystem. The sector is increasingly moving from manufacturing scale toward higher-value research, biopharma, digital health, medical technologies and innovation. This combination makes India relevant both as a market and as a global development and manufacturing partner.",
    corridors:
      "The UK–India corridor has substantial depth in health and life sciences, including digital health, medical devices, regulatory cooperation, supply resilience, biotechnology and research. Southeast Asia offers growing healthcare markets and opportunities in pharma distribution, manufacturing and medical technologies. Africa is strategically important for medicines, vaccines, healthcare capacity, local pharmaceutical manufacturing and resilient supply chains.",
    howWeHelp:
      "Continex can help pharmaceutical, biotechnology, med-tech and healthcare organisations identify Indian partners, manufacturing relationships, customers and institutional connections. Our role can include market mapping, partner identification, B2B engagement, delegation programmes and sustained follow-up. Continex's government and industry networks are particularly useful where commercial opportunities need to be developed alongside institutional and ecosystem relationships.",
    experience: [
      "India–Africa life-sciences and pharmaceutical engagement",
      "Government, institutional and private-sector meetings in healthcare",
      "UK–India pharmaceutical and life-sciences corridor familiarity",
      "Partner, manufacturing and market-access discussions",
    ],
  },
];

// ---- OTHER SECTORS WE SERVE (four compact supporting cards) ----
export const otherSectors = [
  {
    id: "manufacturing-innovation",
    name: "Manufacturing & Innovation",
    tag: "Advanced Manufacturing • Automation • Industrial Technology",
    image:
      "https://images.unsplash.com/photo-1647427060118-4911c9821b82?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    text: "Continex supports international companies bringing advanced manufacturing technologies, automation, precision engineering, industrial digitalisation and innovative production solutions into India — while also helping Indian manufacturers find international technologies, customers and partnerships.",
  },
  {
    id: "renewable-energy",
    name: "Renewable Energy & Clean Technology",
    tag: "Clean Energy • Storage • Decarbonisation",
    image:
      "https://images.unsplash.com/photo-1762381157166-f51ac99ab412?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    text: "India's energy transition is creating opportunities across solar, wind, energy storage, green hydrogen, smart grids and industrial decarbonisation. Continex supports international technology providers seeking Indian customers, partners and ecosystem connections.",
  },
  {
    id: "space-deeptech",
    name: "Space Technology & DeepTech",
    tag: "SpaceTech • AI • Advanced Technology",
    image:
      "https://images.unsplash.com/photo-1708738793054-32b71e3fc822?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    text: "India's expanding private space and deep-technology ecosystem is opening opportunities in satellites, communications, earth observation, electronics, advanced materials, AI and downstream applications — matched to Continex's work across business, technology, government and international collaboration.",
  },
  {
    id: "defence-aerospace",
    name: "Defence & Aerospace",
    tag: "Aerospace • Components • Industrial Collaboration",
    image:
      "https://images.unsplash.com/photo-1680627259725-2c7da3686b97?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    text: "India's focus on localisation and domestic manufacturing is creating opportunities across components, electronics, advanced materials, engineering and technology partnerships. Continex focuses on business and industrial collaboration within applicable regulatory frameworks.",
  },
];


// ---- VIDEO PROOF (placeholder YouTube IDs — replace with real footage) ----
export const proofVideos = [
  {
    id: "v1",
    category: "Leadership",
    title: "Vibhas Ambekar — Helical Technologies, UK",
    youtubeId: "Yk0MFrpVefI",
  },
  {
    id: "v2",
    category: "Trade Mission",
    title: "UK Future Mobility Trade Mission, 2023",
    youtubeId: "DJeVcSaZOjU",
  },
  {
    id: "v3",
    category: "Global Outreach",
    title: "Thailand Outreach — Automotive",
    youtubeId: "uleWclSnxmk",
  },
];

// ---- SERVICES (revised set: dropped Corporate Interviews & Profile Building) ----
export const services = [
  {
    id: "indiaentry",
    icon: "Handshake",
    category: "Market Entry",
    image: "/brand/services/indiaentry.jpg",
    title: "India Entry & International Representation",
    short:
      "Establish a confident local footprint through partner identification, market strategy and on-ground representation.",
    overview:
      "We help overseas companies navigate the scale and diversity of the Indian market. From identifying trusted distributors and OEM partners to providing dedicated local representation, we turn cross-border market entry into long-term commercial presence.",
    whatYouGet: [
      "Qualified distributor & partner identification",
      "Dedicated on-ground Indian market representation",
      "Market-entry strategy & local setup guidance",
      "Direct engagement with key decision makers",
    ],
  },
  {
    id: "b2bmeetings",
    icon: "Users",
    category: "Market Entry",
    image: "/brand/services/b2bmeetings.jpg",
    title: "B2B Meetings & Global Partnerships",
    short:
      "Connect directly with qualified decision-makers across international markets through targeted match-making.",
    overview:
      "Leverage our two-decade network of enterprise leaders, buyers and institutional partners. We design, qualify, schedule and facilitate high-impact B2B meetings that turn initial dialogues into lasting commercial agreements and partnerships.",
    whatYouGet: [
      "Pre-screened target customer & partner profiling",
      "Structured B2B itineraries (virtual & in-person)",
      "Local cultural & negotiation briefing",
      "Post-meeting commercial follow-up & nurturing",
    ],
  },
  {
    id: "businessexpansion",
    icon: "TrendingUp",
    category: "Expansion & Advisory",
    image: "/brand/services/businessexpansion.jpg",
    title: "Business Expansion Services",
    short:
      "De-risk and accelerate growth with market intelligence, sourcing and supply-chain partnering under one roof.",
    overview:
      "A combined advisory offer that pairs ground-level market intelligence with reliable sourcing. We help you size the opportunity, map competitors and regulations, then connect you to vetted manufacturing and supply partners — turning research into executable expansion.",
    whatYouGet: [
      "Market sizing, feasibility & competitive benchmarking",
      "Policy, tariff & regulatory compliance mapping",
      "Vetted supplier discovery & capability audits",
      "Negotiation, quality oversight & supply-chain de-risking",
    ],
  },
  {
    id: "tradeinvestment",
    icon: "Landmark",
    category: "Government & Trade",
    image: "/brand/services/tradeinvestment.jpg",
    title: "Trade & Investment Support Platform for Government Agencies",
    short:
      "A dedicated platform for government agencies to design and deliver trade missions, delegations and sector programmes.",
    overview:
      "We act as a trade and investment support platform for government departments, promotion agencies and industry councils — designing and delivering inbound and outbound trade missions and business delegations, market studies and sector programmes that drive measurable cross-border trade and investment.",
    whatYouGet: [
      "Inbound & outbound trade missions and delegations",
      "Market studies, sector mapping & regulatory guidance",
      "Official & stakeholder engagement and networking",
      "Bilateral trade & investment facilitation",
    ],
  },
];

export const serviceDetails = {
  indiaentry: {
    tagline: "India's opportunity. Your strategy. Our local expertise.",
    whyIndia: {
      heading: "Why India, Why Now?",
      text: "India's expanding network of free trade agreements, growing manufacturing capabilities and shifting global supply chains are strengthening its position as a strategic market for international business.",
      agreements: [
        { name: "Mauritius", year: "2021" },
        { name: "UAE", year: "2022" },
        { name: "Australia", year: "2022" },
        { name: "EFTA (Switzerland, Norway, Iceland & Liechtenstein)", year: "2024" },
        { name: "United Kingdom", year: "2025" },
        { name: "Oman", year: "2025" },
        { name: "New Zealand", year: "2026" },
      ],
      note: "The EU agreement was concluded in negotiations in January 2026 but has not yet been signed; the US interim trade framework remains under negotiation. New Zealand's agreement is scheduled to enter into force on 20 October 2026.",
      closing:
        "Yet India is not a one-size-fits-all market. Success requires a strategy tailored to each business opportunity, supported by an understanding of regional differences, commercial practices, language and cultural nuances. Continex bridges this gap—combining international business experience with local insight, industry relationships and practical execution to help companies enter, establish and grow in India.",
    },
    deliverHeading: "How We Help",
    deliver: [
      { title: "Market Entry Strategy", desc: "Assess opportunities, customer segments, competition and practical routes to market." },
      { title: "Customer & Partner Development", desc: "Identify and engage OEMs, buyers, distributors and strategic partners." },
      { title: "Local Business Representation", desc: "Support market development and customer follow-up without an immediate local-office commitment." },
      { title: "Manufacturing & Collaboration", desc: "Explore localisation, contract manufacturing and technology partnerships." },
      { title: "Establishment Support", desc: "Coordinate local resources and relevant legal, financial and regulatory specialists." },
    ],
    process: {
      heading: "Explore • Engage • Establish",
      text: "Start with opportunity validation, progress to targeted customer engagement, and scale towards partnerships or a permanent presence when commercially justified.",
    },
    operationsNote:
      "In India, having a grip over time and logistics is very important. This is where we bring end-to-end operations that ensure you eat right and plan visits at the right time — as, culturally, India is diverse and needs consistent adaptation based on local knowledge.",
    whyContinex:
      "Nearly two decades of cross-border experience, established industrial networks and practical on-ground business development support—shaped around your specific opportunity.",
    ctaLabel: "Discuss Your India Strategy",
  },
  b2bmeetings: {
    tagline: "The right people. Purposeful meetings. Commercial momentum.",
    intro:
      "A productive B2B meeting starts well before the introduction. Continex identifies relevant organisations, validates mutual interest and brings decision-makers together for focused business engagement.",
    deliverHeading: "What We Deliver",
    deliver: [
      { title: "Targeted B2B Meetings", desc: "Prospect identification, qualification, introductions and coordinated meetings." },
      { title: "Trade Missions & Delegations", desc: "Business programmes, company visits, stakeholder interactions and logistics coordination." },
      { title: "Trade Show Engagement", desc: "Pre-arranged buyer and partner meetings around industry events." },
      { title: "Strategic Partnerships", desc: "Connections for distribution, technology collaboration and manufacturing alliances." },
      { title: "Follow-Through", desc: "Structured communications and next-step coordination after the first meeting." },
    ],
    process: {
      heading: "Our Approach",
      text: "Define the business objective → identify relevant organisations → establish interest → facilitate meetings → support follow-up.",
      note: "Our focus is the relevance of each conversation and its potential to progress—not simply the number of meetings arranged.",
    },
    ctaLabel: "Plan Your B2B Engagement",
  },
  businessexpansion: {
    tagline: "Beyond borders. Closer to customers.",
    intro:
      "Growth in a new market requires sustained engagement, local understanding and a clear commercial plan. Continex works as an extended business development partner for companies seeking customers, channels and strategic opportunities internationally.",
    deliverHeading: "How We Support Growth",
    deliver: [
      { title: "Market Development", desc: "Assess promising geographies and identify practical growth opportunities." },
      { title: "Customer & Channel Development", desc: "Engage buyers, OEMs, distributors and local partners." },
      { title: "Strategic Partnerships", desc: "Explore joint ventures, technology collaboration and manufacturing alliances." },
      { title: "Acquisition Support", desc: "Identify potential targets and coordinate preliminary engagement with appropriate specialists." },
      { title: "Local Representation", desc: "Provide ongoing market outreach, customer coordination and follow-up support." },
    ],
    process: {
      heading: "Flexible Ways to Engage",
      text: "Choose a focused market-development project, a multi-month expansion programme or ongoing local representation—aligned with your commercial readiness and objectives.",
      note: "We help convert initial market interest into a structured pipeline of relationships and opportunities.",
    },
    ctaLabel: "Explore Your Expansion Opportunities",
  },
  tradeinvestment: {
    tagline: "Turning international priorities into meaningful business engagement.",
    intro:
      "Continex supports government departments, trade and investment agencies, diplomatic missions and industry institutions in connecting international business opportunities with the right companies and stakeholders.",
    deliverHeading: "Our Capabilities",
    deliver: [
      { title: "Trade Missions", desc: "Plan and coordinate inbound and outbound business delegations and industry visits." },
      { title: "Investor & Company Outreach", desc: "Identify relevant international companies and facilitate exploratory engagement." },
      { title: "Sector Programmes", desc: "Develop targeted activity across manufacturing, mobility, life sciences, food processing and other industries." },
      { title: "Government-to-Business Engagement", desc: "Connect institutions, trade bodies and private-sector decision-makers." },
      { title: "Programme Delivery", desc: "Coordinate meetings, communications, progress reporting and follow-up activity." },
    ],
    process: {
      heading: "From Strategy to Engagement",
      text: "Translate priority sectors and trade objectives into targeted company outreach, relevant meetings and structured next steps. Programmes are tailored to the institution's mandate and delivery requirements.",
      note: "Our value lies in connecting institutional objectives with commercially relevant private-sector engagement.",
    },
    ctaLabel: "Discuss a Trade or Investment Programme",
  },
};

export const clientLogos = [
  { name: "Global Management Academy", src: "/brand/clients/gma.webp" },
  { name: "Department for Business & Trade", src: "/brand/clients/dbt.jpg" },
  { name: "MYK Laticrete", src: "/brand/clients/myk.jpg" },
  { name: "Pro2 Automotive", src: "/brand/clients/pro2.jpg" },
  { name: "GHANA JET", src: "/brand/clients/ghanajet.jpg" },
  { name: "Full Circle", src: "/brand/clients/fullcircle.jpg" },
  {
    name: "Armagh City, Banbridge & Craigavon Borough Council",
    src: "/brand/clients/abc.jpg",
  },
];

export const blogPosts = [
  {
    id: "blog1",
    image: "https://images.unsplash.com/photo-1589386417686-0d34b5903d23?crop=entropy&cs=srgb&fm=jpg&q=85",
    date: "Jan 3, 2023",
    category: "Insight",
    title: "Common Mistakes Made by Overseas Companies Trying to Find Business in India",
    excerpt:
      "India presents a lucrative opportunity for overseas companies — but many make avoidable mistakes when entering this complex, diverse market.",
    body: [
      "India, with its vast population, growing economy, and diverse market, presents a lucrative opportunity for overseas companies looking to expand their business. However, many companies make avoidable mistakes when trying to enter this complex market.",
      "One of the most common mistakes is treating India as a single, homogeneous market. In reality, India is a collection of highly diverse regional markets, each with its own language, culture and buying behaviour.",
      "Another frequent error is underestimating the importance of local relationships and on-ground presence. Business in India is built on trust and personal connections.",
    ],
  },
  {
    id: "blog2",
    image: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&q=85",
    date: "Jan 3, 2023",
    category: "Market",
    title: "India market opportunity and the reality",
    excerpt:
      "India is a unique market shaped by its scale, diversity and evolving economy. Here's what it really takes to succeed.",
    body: [
      "India is considered a unique market due to its vast population, diverse culture, and evolving economy. Success requires patience, localisation and a willingness to adapt.",
      "The opportunity is real, but so is the complexity. Companies that invest in understanding the ground reality and build strong local partnerships tend to win.",
      "A long-term view, combined with the right local support, dramatically improves the odds of success.",
    ],
  },
  {
    id: "blog3",
    image: "https://images.unsplash.com/photo-1568992687947-868a62a9f521?crop=entropy&cs=srgb&fm=jpg&q=85",
    date: "Jan 3, 2023",
    category: "Strategy",
    title: "Global market entry: how Indian companies can make an impact",
    excerpt:
      "Planning a global market entry is a strategic process. Here's how Indian companies can build genuine international impact.",
    body: [
      "Planning your global market entry is a crucial process that requires careful consideration and strategic thinking.",
      "Indian companies bring competitive strengths — talent, cost efficiency and increasingly world-class products. To make an impact globally, they must invest in brand building, compliance and local representation.",
      "A structured, well-supported market entry reduces costly mistakes and accelerates results.",
    ],
  },
];

export const testimonials = [
  {
    id: 1,
    quote:
      "Continex team is very professional in handling activities across different and difficult cities like Bangalore, Mumbai, Chennai and Hyderabad and have maintained a high standard in engaging customers in India.",
    name: "James Johnston, MD",
    company: "Global Management Academy, UK & Australia",
  },
  {
    id: 2,
    quote:
      "We have used their services several times during the past decade to help with our business expansion, especially in Europe.",
    name: "Muralidhar Yadama, MD",
    company: "MYK Laticrete",
  },
  {
    id: 3,
    quote:
      "We have used the services of Continex in India for over 8 years and will certainly recommend them to companies looking for support in a diverse country like India.",
    name: "Simon Poole, MD",
    company: "Pro2 Automotive, UK",
  },
  {
    id: 4,
    quote:
      "Working with Continex is a rewarding experience in a country which is not always easy to organise events from long distance.",
    name: "Joanna Oliver, MBE",
    company: "Director of Global Programmes",
  },
];

export const newsItems = [
  {
    id: "news1",
    image: "https://img.youtube.com/vi/DJeVcSaZOjU/hqdefault.jpg",
    date: "Jan 2025",
    title: "UK Future Mobility Trade Mission 2025",
    excerpt:
      "Continex supported the UK Future Mobility Trade Mission 2025, connecting UK mobility and automotive companies with Indian partners, institutions and industry across key cities.",
  },
  {
    id: "news2",
    image: "https://images.unsplash.com/photo-1761195696518-6384573549ea?crop=entropy&cs=srgb&fm=jpg&q=85",
    date: "Sept 2018",
    title: "Indian Trade mission to Northern Ireland",
    excerpt:
      "Ten Indian companies from Chennai and Hyderabad visited Northern Ireland as part of an Indian trade delegation to the ABC region.",
  },
  {
    id: "news3",
    image: "https://images.unsplash.com/photo-1573167507387-6b4b98cb7c13?crop=entropy&cs=srgb&fm=jpg&q=85",
    date: "Oct 2016",
    title: "Introduction to Doing Business in India",
    excerpt:
      "Continex was invited by Belfast City Council to speak to its members on India business opportunities.",
  },
];

export const resources = [
  { id: 1, title: "Sales Team, Resellers Recruitment & Training" },
  { id: 2, title: "Capital Restructuring" },
  { id: 3, title: "Business Expansion" },
  { id: 4, title: "Sales Team Recruitment" },
  { id: 5, title: "Construction & Piling Pioneer enters Indian Market" },
  { id: 6, title: "Refrigerated Trailer Concept & Business Overview" },
];

export const contactInfo = {
  phone: "+91 90030 35900",
  phoneRaw: "+919003035900",
  email: "adminteam@continex.in",
  hours: "Monday – Friday, 09:30 – 17:30",
  offices: [
    {
      label: "Registered Office",
      city: "Chennai",
      address:
        "Primus Building, 1st Floor, SP-7A, Guindy Industrial Estate, Chennai 600 032, Tamil Nadu, India",
    },
    {
      label: "Business HQ",
      city: "Bengaluru",
      address:
        "Prestige Atlanta, 80 Feet Road, Koramangala, Bengaluru 560 034, Karnataka, India",
    },
  ],
};
